import React from 'react'

// Bootstrap Components.
import { Button, CardSubtitle, CardText, CardTitle, List, ListInlineItem } from 'reactstrap';

// Font Awesome icons.
import { faShield } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import StepCard from './StepCard';

function RoleOverviewContent({ isModalContent = false, wizardData = {}, roleData = {}, showModal = () => null, toggleAcknowledgement = () => null }) {
    const handleShowModal = (event) => {
        showModal(event.currentTarget.getAttribute('data-role-id'));
    }

    const { currentStepIndex, acceptedAcknowledgements = [] } = wizardData;

    const {
        id: roleId,
        title = '',
        subtitle = '',
        positioning: { shortIntro = '', tagline = '' } = {},
        cardMeta: { teasers = [], highlights = [], expectations = [] } = {},
        registrationSteps = [],
    } = roleData;

  const { description: stepDescription, requiredAcknowledgements = [] } = registrationSteps[currentStepIndex] ?? {};
  const overviewText = (isModalContent ? stepDescription : shortIntro) || shortIntro || stepDescription || 'Role overview is being updated. Review the role standards and continue when details are live.';
  const hasHighlights = highlights.length > 0;
  const hasExpectations = expectations.length > 0;

  const headerContent = (
    <>
        <FontAwesomeIcon fixedWidth size="4x" icon={faShield} />

        <div className="flex-basis-50">
            <CardTitle tag="h3" className="py-1 px-2 mb-0 text-capitalize text-primary-orange-emphasis border-bottom border-primary-orange-subtle permanent-marker-regular fw-semibold">
                {title}
            </CardTitle>

            <CardSubtitle tag="h6" className="pt-2 mb-0 text-light fw-normal">
                {subtitle}
            </CardSubtitle>
            {!!tagline && (
                <CardText className="small text-secondary mb-0 mt-2">
                    {tagline}
                </CardText>
            )}
        </div>

        {teasers.length > 0 && (
            <div className="flex-20 d-flex flex-column ms-auto fs-smaller fw-semibold gap-1">
                {teasers.map(teaser => (
                    <CardText 
                        key={`teaser-${teaser}`}
                        tag="small"
                        className="text-center text-uppercase text-success opacity-75 mb-0"
                    >
                        {teaser}
                    </CardText>
                ))}
            </div>
        )}
    </>
  );

  return (
    <StepCard
      acknowledgements={requiredAcknowledgements}
      acceptedAcknowledgements={acceptedAcknowledgements}    
      headerContent={headerContent}
      toggleAcknowledgement={toggleAcknowledgement}
    >
        <>
            {hasHighlights ? (
                <List type="inline" className="d-flex align-items-center justify-content-around gap-4 py-2 mb-3 rounded-3 bg-darkest border border-primary-orange-subtle text-primary-orange-emphasis shadow-sm">
                    {highlights.map(text => (
                        <ListInlineItem key={`list-item-${text}`} className="fw-semibold mb-0">
                            {text}
                        </ListInlineItem>
                    ))}
                </List>
            ) : (
                <CardText className="small text-secondary text-center mb-3">
                    Highlights will appear once this role track is fully published.
                </CardText>
            )}

            <div>
                <CardText className="mb-4 px-2 px-lg-4 text-start lh-relaxed text-light">
                    {overviewText}
                </CardText>

                <div>
                    <CardText tag="h3" className="fw-semibold text-center text-primary-orange-emphasis mb-3">
                        What It Takes
                    </CardText>

                    {hasExpectations ? (
                        <div className="d-flex justify-content-center align-items-center mb-2 p-3 bg-darkest border-top border-bottom border-primary-orange-subtle">
                            {expectations.map(({ key, label, icon }, index) => (
                                <div key={`expectation-${key}`} className={`same-flex-width px-2 text-center ${index !== expectations.length - 1 ? 'border-end border-primary-orange-subtle' : ''}`}>
                                    <FontAwesomeIcon fixedWidth size="2x" icon={icon} className="mb-2 text-primary-orange-emphasis" />
                                    <CardText className="px-2 text-light fs-smaller mb-0">
                                        {label}
                                    </CardText>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <CardText className="small text-secondary text-center mb-2">
                            Requirements are being finalized. Check the full role details before applying.
                        </CardText>
                    )}
                </div>

                {!isModalContent && (
                    <div className="text-center">
                        {roleId ? (
                            <Button
                                color="primary"
                                data-role-id={roleId}
                                onClick={handleShowModal}
                                className="btn-cta mt-3 border-2 fw-semibold px-4 text-uppercase"
                            >
                                Apply for This Role
                            </Button>
                        ) : (
                            <CardText className="small text-secondary mt-3 mb-0">
                                Role signup is unavailable until this track is active.
                            </CardText>
                        )}
                        <CardText className="small text-secondary mt-2 mb-0">
                            Earlier applications get earlier review.
                        </CardText>
                    </div>
                )}
            </div>
        </>
    </StepCard>
  );
}

export default RoleOverviewContent
